import ARFlag from '@/assets/images/flags/AR.webp'
import COFlag from '@/assets/images/flags/CO.webp'
import MXFlag from '@/assets/images/flags/MX.webp'
import BRFlag from '@/assets/images/flags/BR.webp'
import USFlag from '@/assets/images/flags/US.webp'

export const flagByCountry: Record<string, ImageMetadata> = {
  ['MX']: MXFlag,
  ['AR']: ARFlag,
  ['CO']: COFlag,
  ['BR']: BRFlag,
  ['US']: USFlag,
}
